<template >
  <div>
    <InnerHeader />
    <main role="main">
      <div class="page-content">
        <div class="container py-md-5 py-4">
          <div class="row justify-content-center">
            <div class="col-lg-12 col-sm-12">
              <div class="row align-items-center mb-md-4">
                <div class="col-md-12">
                  <h2 class="page-title mb-md-0 mb-3">
                    <a href="javascript:void(0)"
                      v-on:click="goBack()"
                      ><img
                        src="/images/back-arrow.svg"
                        width="20"
                        alt=""
                        class="me-2"
                    /></a>
                    Viewed Contacts
                  </h2>
                </div>
              </div>
              <div class="card card-body bg-light rounded-l">
              <div class="row align-items-center mb-2">
            <div class="col-lg-7">
            <ul
            class="nav nav-pills mb-3 tab-style-1 "
            id="login-tab"
            role="tablist"
          >
            <li class="nav-item" role="presentation">
              <a
                class="nav-link active"
                id="email-tab"
                data-bs-toggle="pill"
                href="#tab_1"
                role="tab"
                aria-controls="tab_1"
                aria-selected="true"
                >Contacts i viewed (22)</a
              >
            </li>
            <li class="nav-item" role="presentation">
              <a
                class="nav-link"
                id="phone-tab"
                data-bs-toggle="pill"
                href="#tab_2"
                role="tab"
                aria-controls="tab_2"
                aria-selected="false"
                >Viewed my contacts (9)</a
              >
            </li>
          </ul>
           </div>
          </div>
           <div class="tab-content form-style border-top border-bottom pt-4">
            <div
              class="tab-pane fade show active"
              id="tab_1"
              role="tabpanel"
              aria-labelledby="">
            <div class="row mb-2">
                
                <div class="col-md-3">
                   <div
                    id="suggesteProfileSlider"
                    class="carousel slide suggesteProfileSlider"
                    data-bs-ride="carousel" data-bs-interval="false"
                  >
                    <div class="carousel-inner rounded-l cursor-pointer"  data-bs-toggle="modal" data-bs-target="#photosModal">
                      <div class="carousel-item active">
                        <img
                          src="images/profile-female-1.jpg"
                          class="photos"
                          alt="..."
                        />
                      </div>
                      <div class="carousel-item">
                        <img
                          src="images/profile-female-2.jpg"
                          class="photos"
                          alt="..."
                        />
                      </div>
                      <div class="carousel-item">
                        <img
                          src="images/profile-female-3.jpg"
                          class="photos"
                          alt="..."
                        />
                      </div>
                    </div>
                   
                  </div>
                  <div class="text-center my-3 position-relative carousel-outer-nav">
                    <button
                      class="carousel-control-prev"
                      type="button"
                      data-bs-target="#suggesteProfileSlider"
                      data-bs-slide="prev"
                    >
                      <span
                        class="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <span>3/3</span>
                    <button
                      class="carousel-control-next"
                      type="button"
                      data-bs-target="#suggesteProfileSlider"
                      data-bs-slide="next"
                    >
                      <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                    
                    </div>
                   
                </div>
                <div class="col-md-9">
                    <p class="font-medium">S091293821</p>
                    <div class="row">
                      <div class="col-md-6"><label>Candidate Full Name</label></div>
                      <div class="col-md-6 text-md-left"><p class="font-medium">Snehal Shinde</p></div>
                    </div>
                    <div class="row">
                      <div class="col-md-6"><label>Contact Full Name</label></div>
                      <div class="col-md-6 text-md-left"><p class="font-medium">Tukaram Shinde</p></div>
                    </div>
                    <div class="row">
                      <div class="col-md-12"><p class="font-medium">Phone Number</p></div> 
                    </div>
                    <div class="row">
                      <div class="col-md-6"><label class="font-medium">Father</label></div>
                      <div class="col-md-6 text-md-left"><p class="font-medium">+91 9392929191</p></div>
                    </div>
                    <div class="row">
                      <div class="col-md-6"><label class="font-medium">Mother</label></div>
                      <div class="col-md-6 text-md-left"><p class="font-medium">+91 9392929191</p></div>
                    </div>
                    <div class="row">
                      <div class="col-md-6"><label class="font-medium">Other</label></div>
                      <div class="col-md-6 text-md-left"><p class="font-medium">+91 9392929191</p></div>
                    </div>
                    <div class="row">
                      <div class="col-md-6"><label class="font-medium">Email</label></div>
                      <div class="col-md-6 text-md-left"><p class="font-medium">abcsnehal@gmail.com</p></div>
                    </div>
                    <div class="row">
                      <div class="col-md-6"><label class="font-medium">Contact Viewed on</label></div>
                      <div class="col-md-6 text-md-left"><p class="font-medium">11/12/2021</p></div>
                    </div>
                    
                </div>
                <div class="text-center mt-3 col-lg-12">
                      <a href="">SMS/Email these details to me</a>
                    </div>
              </div>
            </div>
            <div class="tab-pane fade" id="tab_2" role="tabpanel" aria-labelledby="">
            <div class="row mb-2">
                
                <div class="col-md-3">
                   <div
                    id="suggesteProfileSlider"
                    class="carousel slide suggesteProfileSlider"
                    data-bs-ride="carousel" data-bs-interval="false"
                  >
                    <div class="carousel-inner rounded-l cursor-pointer"  data-bs-toggle="modal" data-bs-target="#photosModal">
                      <div class="carousel-item active">
                        <img
                          src="images/profile-female-1.jpg"
                          class="photos"
                          alt="..."
                        />
                      </div>
                      <div class="carousel-item">
                        <img
                          src="images/profile-female-2.jpg"
                          class="photos"
                          alt="..."
                        />
                      </div>
                      <div class="carousel-item">
                        <img
                          src="images/profile-female-3.jpg"
                          class="photos"
                          alt="..."
                        />
                      </div>
                    </div>
                   
                  </div>
                  <div class="text-center my-3 position-relative carousel-outer-nav">
                    <button
                      class="carousel-control-prev"
                      type="button"
                      data-bs-target="#suggesteProfileSlider"
                      data-bs-slide="prev"
                    >
                      <span
                        class="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <span>3/3</span>
                    <button
                      class="carousel-control-next"
                      type="button"
                      data-bs-target="#suggesteProfileSlider"
                      data-bs-slide="next"
                    >
                      <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                    
                    </div>
                   
                </div>
                <div class="col-md-9">
                    <p class="font-medium">S091293821</p>
                    <div class="row">
                      <div class="col-md-6"><label>Candidate Name: (Full name)</label></div>
                      <div class="col-md-6 text-md-left"><p class="font-medium">Snehal Shinde</p></div>
                    </div>
                    <div class="row">
                      <div class="col-md-6"><label>Contact Full name</label></div>
                      <div class="col-md-6 text-md-left"><p class="font-medium">Tukaram Shinde</p></div>
                    </div>
                    <div class="row">
                      <div class="col-md-12"><p class="font-medium">Phone Number</p></div>
                      
                    </div>
                    <div class="row">
                      <div class="col-md-6"><label class="font-medium">Father</label></div>
                      <div class="col-md-6 text-md-left"><p class="font-medium">+91 9392929191</p></div>
                    </div>
                    <div class="row">
                      <div class="col-md-6"><label class="font-medium">Mother</label></div>
                      <div class="col-md-6 text-md-left"><p class="font-medium">+91 9392929191</p></div>
                    </div>
                    <div class="row">
                      <div class="col-md-6"><label class="font-medium">Other</label></div>
                      <div class="col-md-6 text-md-left"><p class="font-medium">+91 9392929191</p></div>
                    </div>
                    <div class="row">
                      <div class="col-md-6"><label class="font-medium">Email</label></div>
                      <div class="col-md-6 text-md-left"><p class="font-medium">abcsnehal@gmail.com</p></div>
                    </div>
                    <div class="row">
                      <div class="col-md-6"><label class="font-medium">Contact Viewed on</label></div>
                      <div class="col-md-6 text-md-left"><p class="font-medium">11/12/2021</p></div>
                    </div>
                    
                </div>
                <div class="text-center mt-3 col-lg-12">
                      <a href="">SMS/Email these details to me</a>
                    </div>
              </div>
            </div>
            </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
 <!-- Modal -->
 <div class="modal fade" id="photosModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog photos-gallery modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header border-0 mt-3">
        <button type="button" class="btn-close bg-light" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body ">
         <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel" data-bs-interval="false">
  <div class="carousel-indicators">
    <button class="thumb-btn active" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" aria-current="true" aria-label="Slide 1">
        <img src="images/profile-female-1.jpg" class="thumbnail-img" alt="...">
    </button>
    <button class="thumb-btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2">
        <img src="images/profile-female-2.jpg" class="thumbnail-img" alt="...">
    </button>
    <button class="thumb-btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3">
        <img src="images/profile-female-3.jpg" class="thumbnail-img" alt="...">
    </button>
    <button class="thumb-btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 3">
        
        <img src="images/profile-female-4.jpg" class="thumbnail-img" alt="...">
    </button>
      <button class="thumb-btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 2">
        <img src="images/profile-female-5.jpg" class="thumbnail-img" alt="...">
    </button>
    <button class="thumb-btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 3">
        <img src="images/profile-female-6.jpg" class="thumbnail-img" alt="...">
    </button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="images/profile-female-1.jpg" class="w-100" alt="...">
    </div>
    <div class="carousel-item">
      <img src="images/profile-female-2.jpg" class="w-100" alt="...">
    </div>
    <div class="carousel-item">
      <img src="images/profile-female-3.jpg" class="w-100" alt="...">
    </div>
    <div class="carousel-item">
      <img src="images/profile-female-4.jpg" class="w-100" alt="...">
    </div>
    <div class="carousel-item">
      <img src="images/profile-female-5.jpg" class="w-100" alt="...">
    </div>
    <div class="carousel-item">
      <img src="images/profile-female-6.jpg" class="w-100" alt="...">
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
      </div>
    </div>
  </div>
</div>
    <MainFooter />
  </div>

  <!-- photo gallery  -->
 

</template>
<script>
import InnerHeader from "@/components/InnerHeader";
import MainFooter from "@/components/MainFooter";

export default {
  name: "ViewContact",
  components: {
    InnerHeader,
    MainFooter,
  },
  data() {},
  mounted() {
    // var totalItems = document.getElementsByClassName("carousel-item").length;
    // document.getElementById("slide-counter").innerHTML = totalItems;
  },
  methods: {
    
  },
};
</script>
